import { useEffect, useRef } from "react";
import * as echarts from "echarts";

export type IChartList = {
  date: string;
  sysMin: number;
  sysMax: number;
  diaMin: number;
  diaMax: number;
};

type IProps = {
  chartList: IChartList[];
  onChange: (dataIndex: number) => void;
}

export const Chart = ({ chartList, onChange }: IProps) => {
  const echartDomRef = useRef<HTMLDivElement | null>(null);
  const echartDom = useRef<echarts.ECharts | null>(null);

  const renderSysDiaChart = () => {
    let xAis: string[] = [],
      diaMinData: number[] = [],
      diaMaxData: number[] = [],
      sysMinData: number[] = [],
      sysMaxData: number[] = [],
      array: number[] = [];

    if (!chartList || chartList.length == 0) return;

    if (!echartDomRef.current) return;
    const echartPulDom = echarts.init(echartDomRef.current);

    chartList.forEach((val) => {
      const { date, diaMin, diaMax, sysMax, sysMin } = val;
      xAis.push(date);
      diaMinData.push(diaMin); // 第一个悬空bar 高度
      let cha1 = diaMax - diaMin;
      diaMaxData.push(cha1); //cha1
      sysMinData.push(sysMin); //cha 第二个悬空bar 高度
      sysMaxData.push(sysMax - sysMin);
      array.push(0);
    });

    const size = 10;
    const pagesSize = 10;

    const barWidth = 8;

    const option = {
      textStyle: {
        color: "#999",
        fontSize: 11,
      },
      grid: {
        top: 50,
        right: 25,
        bottom: 40,
        // left: 20
      },
      tooltip: {
        show: true,
        trigger: "axis", //  item
        // alwaysShowContent:true,
        // triggerOn:'mousemove',//|click
        confine: false, //是否将 tooltip 框限制在图表的区域内
        position: function (point: any, _: any, __: any, ___: any, size: any) {
          const width = Math.ceil(size.contentSize[0] / 2);
          return [point[0] - width, -12];
        },
        backgroundColor: "#00C7AF",
        borderColor: "#00C7AF",
        padding: 6, //[6,8]
        textStyle: {
          color: "#fff",
          fontSize: 11,
          // lineHeight:13,
          fontFamily: "Roboto",
        },
        axisPointer: {
          type: "line", //line //shadow
          axis: "x",
          lineStyle: {
            color: "#676A6F",
          },
        },
        formatter: (params: any) => {
          const diaMin = params[0].value;
          const diaMax = params[2].value + diaMin;
          const sysMin = params[4].value;
          const sysMax = params[6].value + sysMin;
          return `SYS：${sysMin}-${sysMax}<br/>DIA：${diaMin}-${diaMax}`;
        },
      },
      xAxis: {
        data: xAis, //["8/13", "8/14", "8/15", "8/16", "8/17"],//
        show: false,
        axisPointer: {
          // snap: true // 自动吸附到最近的x轴
        },
      },
      yAxis: {
        max: 300,
        splitNumber: 3,
        splitLine: {
          // 网格线
          show: true,
          lineStyle: {
            color: ["#676A6F"],
          },
        },
      },
      dataZoom: [
        {
          type: "inside",
          xAxisIndex: 0,
          startValue: size - pagesSize + 1, // 数据窗口范围起始百分比
          endValue: size,
        },
      ],
      series: [
        // 透明块
        {
          type: "bar",
          stack: "a",
          barWidth,
          data: diaMinData, //  [70, 27, 21, 24, 16],
          name: "transparent",
          itemStyle: {
            // borderColor: 'transparent',
            color: "transparent",
          },
        },
        // 黄色第一个圆圈
        {
          type: "scatter",
          name: "scatter",
          color: "#FFF629",
          stack: "a",
          barWidth,
          data: array, //[0, 0, 0, 0, 0]
        },

        {
          type: "bar",
          name: "DIA",
          color: "#FFF629",
          stack: "a",
          barWidth,
          data: diaMaxData, //[20, 27, 21, 24, 36], //
          itemStyle: {
            color: "rgba(255,246,41,0.2)", //柱子颜色
            // barBorderRadius:8
          },
        },
        // 黄色第二个圆圈
        {
          type: "scatter",
          name: "scatter",
          // color: "#FFF629",
          itemStyle: {
            color: (params: any) => {
              return diaMinData[params.dataIndex] == 0 ? "#909192" : "#FFF629";
            },
          },
          stack: "a",
          barWidth,
          data: array, //[0, 0, 0, 0, 0]
        },

        // 透明块
        {
          type: "bar",
          stack: "b",
          barWidth,
          // barGap: '-100%',
          name: "transparent",
          data: sysMinData, //[40, 27, 21, 24, 60], //
          itemStyle: {
            borderColor: "transparent",
            color: "transparent",
          },
        },

        // 绿色第一个圆圈
        {
          type: "scatter",
          name: "scatter",
          itemStyle: {
            color: (params: any) => {
              return sysMinData[params.dataIndex] == 0 ? "#909192" : "#00C7AF";
            },
          },
          stack: "b",
          barWidth,
          data: array, //[0, 0, 0, 0, 0]
        },
        {
          type: "bar",
          name: "SYS",
          color: "#00C7AF",
          stack: "b",
          barWidth,
          barGap: "-100%",
          data: sysMaxData, //[100, 36, 31, 33, 60], //
          itemStyle: {
            color: "rgba(8,199,176,0.2)", //柱子颜色
            // barBorderRadius:[10,10,10,10]
          },
        },
        //绿色第二个圆圈
        {
          type: "scatter",
          name: "scatter",
          // color: "#00C7AF",
          itemStyle: {
            color: (params: any) => {
              return sysMinData[params.dataIndex] == 0 ? "#909192" : "#00C7AF";
            },
          },
          stack: "b",
          barWidth,
          data: array, //[0, 0, 0, 0, 0]
        },
      ],
    };
    echartPulDom.setOption(option as any);

    return echartPulDom;
  };

  useEffect(() => {
    const echartPulDom = renderSysDiaChart();
    const clickHandler = (params: any) => {
      const { dataIndex } = params;
      onChange(dataIndex);
    };

    if (echartPulDom) {
      echartDom.current = echartPulDom;

      echartPulDom.on("click", clickHandler);
    }

    return () => {
      if (echartPulDom) {
        echartPulDom.off("click", clickHandler);
        echartPulDom.dispose();
      }
    };
  }, [echartDomRef.current, chartList]);

  return (
    <div
      ref={echartDomRef}
      id="echart"
      className="mx-auto min-w-[320px] max-w-[90%] h-[260px]"
    ></div>
  );
};
